<div class="filter-overlay" [class.open]="isOpen" (click)="close()"></div>
<div class="filter-sidenav" [class.open]="isOpen">
  
  <!-- Main Filter View - ENTIRE view including header -->
  <ng-container *ngIf="currentView === 'filter-side-nav'">
    <div class="filter-header">
      Filters
      <img src="assets/newimages/Close.png" (click)="close()" alt="Close">
    </div>

    <div class="filter-content">
      <div class="filter-section">
        Basic Filters
      </div>

      <!-- <div class="filter-item" (click)="toggleSection('deliveryStatus')">
        <span>Delivery status</span>
        <span><img src="assets/newimages/Forward.jpg" alt="Forward"></span>
      </div> -->

      <div class="filter-item" (click)="toggleSection('order-date-range')">
        <span>Order Range</span>
        <span><img src="assets/newimages/Forward.jpg" alt="Forward"></span>
      </div>

      <!-- <div class="filter-item" (click)="toggleSection('products')">
        <span>Products</span>
        <span><img src="assets/newimages/Forward.jpg" alt="Forward"></span>
      </div> -->
    </div>

  <div class="filter-footer">
    <img src="assets/newimages/Viewbutton.png" (click)="applyFilters()" alt="View Results">
    <img src="assets/newimages/clear.png" (click)="clearFilters()" alt="Clear">
  </div>
  </ng-container>

  <!-- Order Date Range View - Completely replaces filter view -->
  <app-order-date-range 
    *ngIf="currentView === 'order-date-range'"
    (navigateBack)="goBackToMain()"
    (rangeSelected)="handleRangeSelection($event)">
  </app-order-date-range>

</div>